var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"central-view",attrs:{"column":""}},[_c('NotesCard'),_vm._v(" "),_c('BoxCard'),_vm._v(" "),_c('BoardsCard'),_vm._v(" "),_c('GraphsCard')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dd39ad4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CentralView.vue
// module id = nXEJ
// module chunks = 1